import React from 'react';
import {BackgroundWithGradient} from '../BackgroundWithGradient';

export function PerformanceInsights() {
  return (
    <BackgroundWithGradient
      description="progress, spot patterns, and get smart suggestions to stay inspired and improve. Your growth, reimagined"
      heading="Your work tells a story—Let’s make it extraordinary!Track"
      title="Performance Insights"
      highlightText="story"
      image={require('assets/illustrations/performance-insights.png')}
    />
  );
}
